import { Backdrop, CircularProgress, styled } from '@mui/material'
import type { FC } from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const Container = styled('div')({
  width: '100%',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '20px',
  fontFamily: 'Gabarito',
})

interface LogoutProps {}

export const Logout: FC<LogoutProps> = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(true) // State to control modal visibility

  useEffect(() => {
    // Add any logout logic here (e.g., clearing tokens, state, etc.)
    const logoutTimer = setTimeout(() => {
      // Add logout logic here
      // For example: clearing localStorage
      localStorage.clear()

      // Redirect to login page after 2 seconds
      setOpen(false) // Close modal
      navigate('/')
    }, 2000) // 2000 milliseconds = 2 seconds

    // Cleanup the timer if component unmounts
    return () => clearTimeout(logoutTimer)
  }, [navigate])

  return (
    <>
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container>Logging out...</Container>
    </>
  )
}
